//import React, { useState } from "react";
import React, { useState, useEffect, useRef } from "react";
import { toast } from 'react-toastify';

import {
    registerConsumer,
    updateConsumer
} from '../api/consumerService';

const initialForm = {
    Name: "",
    Email: "",
    Mobile: "",
    ConsumerNumber: "",
    Address: "",
    SanctionNumber: "",
    SanctionCapacity: "",
    CapacitySolarPV: "",
    ModuleMake: "",
    ModuleCount: "",
    TotalCapacity: "",
    InverterMakeModel: "",
    InverterRating: "",
    TypeOfCharge: "",
    InverterCapacity: "",
    SanctionDate: "",
    ApplicationNumber: "",
    WattagePerModule: "",
    Category: "",
    SrNoOfPVModule: "",
    SignaturePath: "",
    AadharNumber: "",
    AadharCardPath: "",
    InstallationDate: "",
    Division: "",
    District: "",
    AgreementDate: "",
    RecordStatusId: "",
    CreatedBy: "",
    CreatedDate: "",
    ModifiedBy: "",
    ModifiedDate: "",
    TimeStamp: ""
};
const requiredFields = [
    "Name",
    "Email",
    "Mobile",
    "ConsumerNumber",
    "Address"
];


// const FileUpload = ({ label, onChange, preview }) => (
//     <div className="flex flex-col">
//         <label className="text-sm font-medium text-gray-700 mb-1">{label}</label>
//         <input
//             type="file"
//             accept="image/*"
//             onChange={onChange}
//             className="px-4 py-2 rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//         />
//         {preview && (
//             <img
//                 src={preview}
//                 alt="Preview"
//                 className="h-24 w-auto mt-2 border border-gray-300 rounded-lg object-contain"
//             />
//         )}
//     </div>
// );

const ConsumerForm = ({ initialData, onClose }) => {
    const [form, setForm] = useState(initialData || initialForm);
    const [signatureFile, setSignatureFile] = useState(null);
    const [aadharFile, setAadharFile] = useState(null);
    const [previewSignature, setPreviewSignature] = useState("");
    const [previewAadhar, setPreviewAadhar] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const isEditMode = !!initialData;

    const signaturePasteAreaRef = useRef(null);
    const aadharPasteAreaRef = useRef(null);

    useEffect(() => {
        const handlePaste = (e) => {
            const items = e.clipboardData?.items;
            if (!items) return;

            for (const item of items) {
                if (item.type.startsWith("image")) {
                    const blob = item.getAsFile();
                    if (!blob) return;

                    const previewURL = URL.createObjectURL(blob);
                    const active = document.activeElement;

                    if (signaturePasteAreaRef.current?.contains(active)) {
                        setSignatureFile(blob);
                        setPreviewSignature(previewURL);
                        setErrors(prev => ({ ...prev, signatureFile: '' }));
                    } else if (aadharPasteAreaRef.current?.contains(active)) {
                        setAadharFile(blob);
                        setPreviewAadhar(previewURL);
                        setErrors(prev => ({ ...prev, aadharFile: '' }));
                    }
                    break;
                }
            }
        };

        window.addEventListener("paste", handlePaste);
        return () => window.removeEventListener("paste", handlePaste);
    }, []);


    const [errors, setErrors] = React.useState({
        signatureFile: '',
        aadharFile: '',
    });
    const excludedFields = [
        "recordstatusid",
        "createdby",
        "createddate",
        "modifiedby",
        "modifieddate",
        "timestamp",
        "id"
    ];
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (setter, previewSetter, errorKey) => (e) => {
        const file = e.target.files[0];
        setter(file);
        if (file) {
            previewSetter(URL.createObjectURL(file));
            setErrors((prev) => ({ ...prev, [errorKey]: '' })); // Clear error
        }
    };


    function FileUpload({ label, onChange, preview, error, pasteRef }) {
        const inputRef = useRef(null);

        return (
            <div className="flex flex-col">
                <label className="mb-1 text-sm font-medium text-gray-700">{label}</label>

                <div
                    ref={pasteRef}
                    tabIndex={0}
                    className="h-32 border-2 border-dashed rounded-lg p-4 flex flex-col items-center justify-center text-center text-gray-500 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onClick={() => inputRef.current?.click()}
                >
                    <div className="pointer-events-none select-none">
                        📱 Tap to upload or long-press to paste image on tablet<br />
                        💻 Or paste (Ctrl+V) on desktop
                    </div>
                    <span
                        contentEditable
                        suppressContentEditableWarning
                        className="absolute opacity-0 w-0 h-0"
                    ></span>
                </div>


                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    onChange={onChange}
                    hidden
                />

                {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

                {preview && (
                    <img src={preview} alt="Preview" className="mt-2 max-w-xs max-h-32 border rounded" />
                )}
            </div>
        );
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setSubmitted(false);

        const fixDate = (d) => (d ? new Date(d).toISOString() : "");

        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => {
            formData.append(key, key.toLowerCase().includes("date") ? fixDate(value) : value);
        });

        if (signatureFile) formData.append("SignatureFile", signatureFile);
        if (aadharFile) formData.append("AadharCardFile", aadharFile);

        try {
            if (isEditMode) {
                // await updateConsumer(initialData.id, formData);
                // toast.success("Consumer record updated successfully");
                try {
                    debugger;
                    const response = await updateConsumer(initialData.id, formData);
                    if (response?.success) {
                        toast.success(response.message);
                    } else {
                        toast.error(response?.message || "Updation failed");
                    }
                } catch (error) {
                    toast.error(error.response?.message || "An error occurred during updation");
                    console.error("Updation error:", error);
                }



            } else {
                let valid = true;
                const newErrors = { signatureFile: '', aadharFile: '' };
                if (!signatureFile) {
                    newErrors.signatureFile = 'Please upload signature';
                    valid = false;
                }

                // if (!aadharFile) {
                //     newErrors.aadharFile = 'Please upload Aadhar card';
                //     valid = false;
                // }
                setErrors(newErrors);
                if (!valid) return;

                // await registerConsumer(formData);
                // toast.success("Consumer record saved successfully");
                try {
                    debugger;
                    const response = await registerConsumer(formData);
                    if (response?.success) {
                        toast.success(response.message);
                    } else {
                        toast.error(response?.message || "Registration failed");
                    }
                } catch (error) {
                    toast.error(error.response?.message || "An error occurred during registration.");
                    console.error("Registration error:", error);
                }
            }
            setSubmitted(true);
            onClose();
        } catch (err) {
            console.error(err);
            toast.error("Failed to save consumer record");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="p-8 max-w-5xl mx-auto bg-white shadow-2xl rounded-2xl space-y-8"
        >
            <div className="border-b pb-4">
                <h2 className="text-2xl font-semibold text-gray-800">
                    {isEditMode ? "Edit Consumer Record" : "Create Consumer Record"}
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                    Please fill in all the fields carefully.
                </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {Object.entries(form)
                    .filter(([key]) => !excludedFields.includes(key.toLowerCase()))
                    .map(([key, value]) => {
                        const label = key
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^./, (str) => str.toUpperCase());
                        const isDate = key.toLowerCase().includes("date");
                        if (!isEditMode && ["signaturepath", "aadharcardpath"].includes(key.toLowerCase())) {
                            return null;
                        }
                        if (isEditMode && key.toLowerCase().includes("path") && value) {
                            return (
                                <div key={key} className="flex flex-col w-[250px]">
                                    <label className="mb-1 text-sm font-medium text-gray-700">{label}</label>
                                    <a
                                        href={`${value}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-blue-600 underline"
                                    >
                                        View File
                                    </a>
                                </div>
                            );
                        }
                        if (key.toLowerCase() === "category") {
                            return (
                                <div key={key} className="flex flex-col">
                                    <label htmlFor={key} className="mb-1 text-sm font-medium text-gray-700">
                                        {label}
                                    </label>
                                    <select
                                        id={key}
                                        name={key}
                                        value={value || ""}
                                        onChange={handleChange}
                                        required={requiredFields.includes(key)}
                                        className="px-2 py-2 rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-800"
                                    >
                                        <option value="">-- Select Category --</option>
                                        <option value="Private Sector">Private Sector</option>
                                        <option value="Government Sector">Government Sector</option>
                                    </select>
                                </div>
                            );
                        }

                        return (
                            <div key={key} className="flex flex-col">
                                <label
                                    htmlFor={key}
                                    className="mb-1 text-sm font-medium text-gray-700"
                                >
                                    {label}
                                </label>
                                <input
                                    type={isDate ? "date" : "text"}
                                    id={key}
                                    name={key}
                                    value={isDate ? (value ? value.slice(0, 10) : "") : value}
                                    onChange={handleChange}
                                    required={requiredFields.includes(key)}
                                    className="px-2 py-2 rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-800"
                                    placeholder={label}
                                />

                            </div>
                        );
                    })}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <FileUpload
                    label="Upload Signature"
                    onChange={handleFileChange(setSignatureFile, setPreviewSignature, 'signatureFile')}
                    preview={previewSignature}
                    error={errors.signatureFile}
                    pasteRef={signaturePasteAreaRef}
                />
                <FileUpload
                    label="Upload Aadhar Card"
                    onChange={handleFileChange(setAadharFile, setPreviewAadhar, 'aadharFile')}
                    preview={previewAadhar}
                    error={errors.aadharFile}
                    pasteRef={aadharPasteAreaRef}
                />
            </div>

            <div className="flex gap-4 mt-6 justify-center items-center">
                {/* Submit/Update Button */}
                <button
                    type="submit"
                    className="bg-blue-600 hover:bg-sky-700 text-white font-medium px-5 py-2 text-sm rounded-md shadow-sm transition"
                    disabled={submitting}
                >
                    {submitting ? (isEditMode ? "Updating..." : "Saving...") : (isEditMode ? "Update" : "Submit")}
                </button>

                {/* Cancel Button */}
                <button
                    type="button"
                    onClick={onClose}
                    className="bg-gray-200 hover:bg-gray-300 text-black font-medium px-5 py-2 text-sm rounded-md shadow-sm transition"
                >
                    Cancel
                </button>

                {/* Success Message */}
                {submitted && (
                    <div className="text-green-600 text-sm font-medium sm:ml-4">
                        ✅ Consumer record {isEditMode ? "updated" : "saved"} successfully.
                    </div>
                )}
            </div>

        </form>
    );
};

export default ConsumerForm;
